/* eslint-disable indent */
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { newLayout } from '../../../../theme';

export const StyledTypography = styled(Typography)`
  && {
    display: flex;
    align-items: center;
    font-size: ${newLayout.fontSize.body2};
    gap: ${newLayout.spacing.s2};
    div {
      marginright: ${newLayout.spacing.s3};
    }
  }
`;
